import React from 'react';
import { motion } from 'framer-motion';
import { SparkleIcon } from './icons';
export const Revelation: React.FC = () => {
  return <section className="py-24 px-6 sm:px-8 lg:px-12 bg-forest text-cream text-center" data-id="element-240">
      <div className="max-w-3xl mx-auto" data-id="element-241">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-242">
          <span className="text-xs font-bold tracking-[0.2em] text-gold uppercase block mb-6" data-id="element-243">
            The 20% Fresh Rotation
          </span>

          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl mb-8 leading-tight" data-id="element-244">
            What if I told you that you don't need to be a scientist or a
            millionaire to save your dog?
          </h2>

          <p className="text-lg sm:text-xl text-cream/80 leading-relaxed mb-12" data-id="element-245">
            The secret isn’t a magic pill. Recent studies show that adding just
            20% fresh, specific "bio-active" foods to a kibble diet can
            dramatically alter your dog's health trajectory. I’ve spent years
            distilling complex epigenetic science into a 10-minute daily
            protocol that fits into a busy US professional's schedule.
          </p>

          <div className="bg-forest-dark border border-gold/30 p-8 rounded-xl shadow-2xl inline-block" data-id="element-246">
            <div className="flex justify-center mb-4" data-id="element-247">
              <SparkleIcon className="w-8 h-8 text-gold" data-id="element-248" />
            </div>
            <h3 className="font-serif text-3xl sm:text-4xl text-gold mb-2" data-id="element-249">
              Up to 90% Lower Cancer Risk
            </h3>
            <p className="text-sm font-medium tracking-wide text-cream/70 uppercase" data-id="element-250">
              When adding specific bio-active fresh foods
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
};